module.exports = __webpack_public_path__ + "static/achievement-4-7c6b94c77b1526102738ac1d9de578ab.svg";